<script setup lang="ts">
type Props = {
  title: string;
};

const { title } = defineProps<Props>();
</script>

<template>
  <div :class="$style.emptyRewards">
    <NuxtIcon
      :class="$style.emptyRewardsIcon"
      name="info"
    />

    <div :class="$style.emptyRewardsText">
      <span>{{ title }}</span>
    </div>
  </div>
</template>

<style module lang="postcss">
.emptyRewards {
  @apply flex items-center justify-center gap-4 p-5;

  .emptyRewardsIcon {
    @apply text-4xl text-primary;
  }

  .emptyRewardsText {
    @apply text-center text-xl text-texts font-semibold;
  }
}
</style>
